import { Component } from '@angular/core';

@Component({
  selector: 'app-conditions-accept-text',
  templateUrl: './conditions-accept-text.component.html',
})

export class ConditionsAcceptComponent {}
